import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import ScrollTabs from '../../component/tab/scroll-tabs.component';
import RiskOrderListCloud from './risk-order-list-cloud.component';
import i18n from '../../i18n';
import RiskThresholdSettings from './risk-threshold-settings.component';
import RiskOrderList from './risk-order-list.component';

const IntelligentRiskControlPage: React.FC = observer(() => {
    const [activeTabIndex,setActiveTabIndex] = React.useState(0);

    const TAB_DATA = [
        {
            // 即时风险订单列表
            title: i18n.t('intelligent_risk_control_page_tab_instant_order_list'),
        },
        {
            // 云端风险订单列表
            title: i18n.t('intelligent_risk_control_page_tab_cloud_order_list'),
        },
        {
            // 风控阈值设置
            title: i18n.t('intelligent_risk_control_page_text_risk_control_threshold_settings'),
        }
    ];

    const handleChangeTab = (index: number) => {
        setActiveTabIndex(index);
    };

    const renderTabContent = () => {
        switch (activeTabIndex) {
            case 0:
                // 即时风险订单列表
                return (
                    <RiskOrderList />
                );
            case 1:
                // 云端风险订单列表
                return (
                    <RiskOrderListCloud />
                );
            case 2:
                // 风控阈值设置
                return (
                    <RiskThresholdSettings />
                )
            default:
                return null;
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <ScrollTabs
                    data={TAB_DATA}
                    activeIndex={activeTabIndex}
                    onClick={handleChangeTab}
                />
            </Box>

            {renderTabContent()}

        </Box>
    );
});

export default IntelligentRiskControlPage;
